module.exports = __webpack_public_path__ + "static/media/Crayon-100.33d11a09.webp";